<!-- Backdrop -->
<div
  *ngIf="isOpen"
  id="sem-permissao-modal-backdrop"
  class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
  (click)="onBackdropClick($event)"
  (keydown.escape)="onFechar()"
>
  <!-- Modal -->
  <div
    id="sem-permissao-modal"
    class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-modal-in"
  >
    <!-- Header com ícone -->
    <div id="sem-permissao-modal-header" class="flex flex-col items-center pt-8 pb-4 px-6">
      <div class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-red-500 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v.01M12 9v3m0-9a9 9 0 110 18 9 9 0 010-18z" />
        </svg>
      </div>

      <h2 id="sem-permissao-modal-titulo" class="text-lg font-bold text-gray-800 dark:text-gray-100 text-center">
        Acesso Negado
      </h2>

      <p id="sem-permissao-modal-mensagem" class="mt-2 text-sm text-gray-500 dark:text-gray-400 text-center leading-relaxed">
        Você não possui permissão para acessar este recurso.
        Tente trocar o contexto ou entre em contato com o administrador.
      </p>
    </div>

    <!-- Divisor -->
    <div class="border-t border-gray-200 dark:border-gray-700 mx-6"></div>

    <!-- Ações -->
    <div id="sem-permissao-modal-acoes" class="p-4 flex flex-col gap-2">
      <!-- Trocar contexto -->
      <button
        id="sem-permissao-modal-btn-trocar-contexto"
        (click)="onTrocarContexto()"
        class="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl
               bg-blue-600 dark:bg-blue-500 hover:bg-blue-700 dark:hover:bg-blue-400 active:scale-[0.98]
               text-white font-medium text-sm
               transition-all duration-150"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
        </svg>
        Trocar Contexto
      </button>

      <!-- Fechar -->
      <button
        id="sem-permissao-modal-btn-fechar"
        (click)="onFechar()"
        class="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl
               border border-gray-300 dark:border-gray-600
               text-gray-700 dark:text-gray-300 font-medium text-sm
               hover:bg-gray-50 dark:hover:bg-gray-700 active:scale-[0.98]
               transition-all duration-150"
      >
        Fechar
      </button>
    </div>

    <!-- Código do erro -->
    <p id="sem-permissao-modal-codigo" class="pb-4 text-center text-xs text-gray-400 dark:text-gray-500">
      Erro 403 — Forbidden
    </p>
  </div>
</div>
